import {createStore, applyMiddleware, compose} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import {persistStore} from 'redux-persist';
import {routerMiddleware} from 'connected-react-router'
import {responsiveStoreEnhancer} from 'redux-responsive'

import customMiddlewares from './middlewares';
import reducers, {history} from './index';

const middlewares = [ReduxThunk, routerMiddleware(history), ...customMiddlewares];

export default () => {

  const store = createStore(
    reducers,
    {},
    __DEV__
      ? composeWithDevTools(responsiveStoreEnhancer, applyMiddleware(...middlewares))
      : compose(responsiveStoreEnhancer, applyMiddleware(...middlewares)),
  );

  const persistor = persistStore(store);

  return {store, persistor, history};
};
